import { render } from "./BoxesView.vue?vue&type=template&id=6a6de12a&scoped=true"
import script from "./BoxesView.vue?vue&type=script&lang=js"
export * from "./BoxesView.vue?vue&type=script&lang=js"

import "./BoxesView.vue?vue&type=style&index=0&id=6a6de12a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6de12a"]])

export default __exports__